<template>
  <div class="icon-frame ml-3" @click="action">
    <svg class="lg:block md:block hidden" width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="type === 'edit'">
      <path d="M5.45872 4.67432H2.78349C2.31048 4.67432 1.85684 4.86222 1.52237 5.19669C1.1879 5.53116 1 5.98479 1 6.4578V14.4835C1 14.9565 1.1879 15.4101 1.52237 15.7446C1.85684 16.0791 2.31048 16.267 2.78349 16.267H10.8092C11.2822 16.267 11.7358 16.0791 12.0703 15.7446C12.4048 15.4101 12.5927 14.9565 12.5927 14.4835V11.8083" stroke="#A9AEBF" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M5.46021 11.8091H8.13544L15.7153 4.22929C16.07 3.87453 16.2693 3.39338 16.2693 2.89167C16.2693 2.38997 16.07 1.90882 15.7153 1.55406C15.3605 1.1993 14.8793 1 14.3776 1C13.8759 1 13.3948 1.1993 13.04 1.55406L5.46021 9.13388V11.8091Z" stroke="#A9AEBF" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M11.7009 2.89355L14.3762 5.56879" stroke="#A9AEBF" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>

    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="type === 'copy'">
      <path d="M10.5 10.5V13.5C10.5 14.0523 10.0523 14.5 9.5 14.5H1.5C0.947715 14.5 0.5 14.0523 0.5 13.5V5.5C0.5 4.94772 0.947715 4.5 1.5 4.5H4.5M4.5 1.5V9.5C4.5 10.0523 4.94772 10.5 5.5 10.5H13.5C14.0523 10.5 14.5 10.0523 14.5 9.5V1.5C14.5 0.947716 14.0523 0.5 13.5 0.5H5.5C4.94772 0.5 4.5 0.947715 4.5 1.5Z" stroke="#A9AEBF" />
    </svg>

    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="type === 'chart'">
      <path d="M0.5 14.5H0V15H0.5V14.5ZM6.5 5.5L6.9 5.2C6.80264 5.07018 6.64833 4.99569 6.48613 5.00019C6.32392 5.00469 6.17399 5.08763 6.08397 5.22265L6.5 5.5ZM9.5 9.5L9.1 9.8C9.19566 9.92754 9.3464 10.0018 9.50581 9.99997C9.66523 9.99811 9.8142 9.92035 9.90687 9.79062L9.5 9.5ZM0 0V14.5H1V0H0ZM0.5 15H15V14H0.5V15ZM2.91603 11.7774L6.91603 5.77735L6.08397 5.22265L2.08397 11.2226L2.91603 11.7774ZM6.1 5.8L9.1 9.8L9.9 9.2L6.9 5.2L6.1 5.8ZM9.90687 9.79062L14.9069 2.79062L14.0931 2.20938L9.09313 9.20938L9.90687 9.79062Z" fill="#A9AEBF"/>
    </svg>

    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="type === 'pause'">
      <rect x="0.5" y="0.5" width="4" height="11" rx="0.5" stroke="#A9AEBF"/>
      <rect x="7.5" y="0.5" width="4" height="11" rx="0.5" stroke="#A9AEBF"/>
    </svg>

    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="type === 'publish'">
      <path d="M15 0.999756L15.4596 1.19672C15.5401 1.00879 15.4981 0.790772 15.3536 0.646202C15.209 0.501633 14.991 0.459646 14.803 0.540183L15 0.999756ZM1 6.99976L0.80304 6.54018C0.630457 6.61415 0.513861 6.77857 0.501148 6.9659C0.488434 7.15323 0.581745 7.3319 0.742752 7.4285L1 6.99976ZM9 14.9998L8.57125 15.257C8.66786 15.418 8.84652 15.5113 9.03386 15.4986C9.22119 15.4859 9.38561 15.3693 9.45957 15.1967L9 14.9998ZM14.803 0.540183L0.80304 6.54018L1.19696 7.45933L15.197 1.45933L14.803 0.540183ZM0.742752 7.4285L5.74275 10.4285L6.25725 9.57101L1.25725 6.57101L0.742752 7.4285ZM5.57125 10.257L8.57125 15.257L9.42875 14.7425L6.42875 9.74251L5.57125 10.257ZM9.45957 15.1967L15.4596 1.19672L14.5404 0.802796L8.54043 14.8028L9.45957 15.1967ZM14.6464 0.646202L5.64645 9.6462L6.35355 10.3533L15.3536 1.35331L14.6464 0.646202Z" fill="#A9AEBF"/>
    </svg>

    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="type === 'delete'">
      <path d="M1 4.4165H14.668" stroke="#A9AEBF" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M6.12549 7.83447V12.96" stroke="#A9AEBF" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M9.5437 7.83447V12.96" stroke="#A9AEBF" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M1.85547 4.4165L2.70972 14.6675C2.70972 15.1206 2.88972 15.5552 3.21012 15.8756C3.53053 16.196 3.96509 16.376 4.41821 16.376H11.2522C11.7053 16.376 12.1399 16.196 12.4603 15.8756C12.7807 15.5552 12.9607 15.1206 12.9607 14.6675L13.8149 4.4165" stroke="#A9AEBF" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M5.27173 4.41699V1.85425C5.27173 1.62769 5.36173 1.41041 5.52193 1.2502C5.68213 1.09 5.89942 1 6.12598 1H9.54297C9.76953 1 9.98681 1.09 10.147 1.2502C10.3072 1.41041 10.3972 1.62769 10.3972 1.85425V4.41699" stroke="#A9AEBF" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>

    <svg width="13" height="16" viewBox="0 0 13 16" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="type === 'play'">
      <path d="M1 0.999756V14.9998L12 7.99976L1 0.999756Z" stroke="#A9AEBF" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>

    <i class="lg:block md:block hidden pi pi-eye text-gray-300" v-if="type === 'browse'"></i>

    <i class="pi pi-send text-gray-300" v-if="type === 'release'"></i>

    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-lightbulb-icon lucide-lightbulb w-5 h-5 -mx-1.5" style="color:#C5C8D3;" v-if="type === 'suggest'">
      <path d="M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5"/>
      <path d="M9 18h6"/>
      <path d="M10 22h4"/>
    </svg>
  </div>
</template>

<script>

export default {
  name: 'ActionIcon',
  props: {
    type: {
      type: String,
      default: 'edit'
    }
  },
  methods: {
    action() {
      this.$emit('action')
    }
  }
}

</script>

<style lang="scss" scoped>

.icon-frame {
  cursor: pointer;
}

</style>